import { render, staticRenderFns } from "./ND-PH-Notice.vue?vue&type=template&id=7f724ee6&scoped=true&"
import script from "./ND-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./ND-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./ND-PH-Notice.vue?vue&type=style&index=0&id=7f724ee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f724ee6",
  null
  
)

export default component.exports